<template>
    <div class="background">
        <img src="../assets/img/zxdt-bj.png" class="nrbj"/>

        <!--智能客服-->
        <CustomerService/>
        <!--在线留言-->
        <OnlineMsg/>

        <div class="nrBox">
            <img src="../assets/img/zxdt2.png" class="jsbanner"/>
            <div class="nrMain">
                <!--筛选条件-->
                <div class="search">
                    <a-form class="search-form" layout="inline">
                        <a-form-item style="text-align: right; padding-bottom: 10px; padding-top: 8px">
                            <a-input
                                    v-model="search.newsName"
                                    placeholder="请输入关键词"
                                    style="width: 300px;  height: 40px"
                            />
                          <a-range-picker v-model="search.publicTime" size="large" style="width: 230px; margin-right: 10px;"/>
                            <a-button type="primary" icon="search" style="height: 40px" @click="getProduces">
                                搜索
                            </a-button>
                        </a-form-item>
                    </a-form>
                </div>
                <!--结果列表-->
                <div class="result">
                    <a-tabs default-active-key="0" style="background-color: white; padding-bottom: 20px" @change="changeType">
                        <a-tab-pane key="0" >
                    <span slot="tab">
                        <a-icon type="container" />
                        新闻动态
                    </span>
                            <a-spin :spinning="spinning" tip="搜索中....">
                                <a-list item-layout="vertical" size="large" :data-source="newsList" :pagination="pagination">
                                    <a-list-item class="pro_bg"
                                                 slot="renderItem" key="item.id" slot-scope="item, index">
                                        <div>
                                            <div class="dt_12_5_wz2a" @click="openDetail(item.id)">
                                                {{item.title}}&nbsp;&nbsp;<!--<img src="../assets/img/hz61.png">&nbsp;&nbsp;<img src="../assets/img/hz62.png">-->
                                            </div>
                                            <div class="dt_12a">
                                                <img src="../assets/img/hz63.png">&nbsp;&nbsp;{{item.createTime.length>19?item.createTime.substring(0,19):item.createTime}}&nbsp;&nbsp;&nbsp;&nbsp;<img src="../assets/img/hz64.png">&nbsp;&nbsp;{{item.author}}
                                            </div>
                                            <div class="dt_12c" @click="openDetail(item.id)">
                                                {{getContent(item.content)}}
                                            </div>
                                        </div>
                                    </a-list-item>
                                </a-list>
                            </a-spin>
                        </a-tab-pane>
<!--                        <a-tab-pane key="1" >
                    <span slot="tab">
                        <a-icon type="read" />
                        政策资讯
                    </span>
                            <a-spin :spinning="spinning" tip="搜索中....">
                                <a-list item-layout="vertical" size="large" :data-source="policiesList" :pagination="pagination">
                                    <a-list-item class="pro_bg"
                                                 slot="renderItem" key="item.id" slot-scope="item, index">
                                        <div>
                                            <div class="dt_12_5_wz2a" @click="openDetail(item.id)">
                                                {{item.title}}&nbsp;&nbsp;&lt;!&ndash;<img src="../assets/img/hz61.png">&nbsp;&nbsp;<img src="../assets/img/hz62.png">&ndash;&gt;
                                            </div>
                                            <div class="dt_12a">
                                                <img src="../assets/img/hz63.png">&nbsp;&nbsp;{{item.createTime.length>19?item.createTime.substring(0,19):item.createTime}}&nbsp;&nbsp;&nbsp;&nbsp;<img src="../assets/img/hz64.png">&nbsp;&nbsp;{{item.author}}
                                            </div>
                                            <div class="dt_12c" @click="openDetail(item.id)">
                                                {{getContent(item.content)}}
                                            </div>
                                        </div>
                                    </a-list-item>
                                </a-list>
                            </a-spin>
                        </a-tab-pane>
                        <a-tab-pane key="2" >
                    <span slot="tab">
                        <a-icon type="money-collect" />
                        金融知识
                    </span>
                            <a-spin :spinning="spinning" tip="搜索中....">
                                <a-list item-layout="vertical" size="large" :data-source="policiesList" :pagination="pagination">
                                    <a-list-item class="pro_bg"
                                                 slot="renderItem" key="item.id" slot-scope="item, index">
                                        <div>
                                            <div class="dt_12_5_wz2a" @click="openDetail(item.id)">
                                                {{item.title}}&nbsp;&nbsp;&lt;!&ndash;<img src="../assets/img/hz61.png">&nbsp;&nbsp;<img src="../assets/img/hz62.png">&ndash;&gt;
                                            </div>
                                            <div class="dt_12a">
                                                <img src="../assets/img/hz63.png">&nbsp;&nbsp;{{item.createTime.length>19?item.createTime.substring(0,19):item.createTime}}&nbsp;&nbsp;&nbsp;&nbsp;<img src="../assets/img/hz64.png">&nbsp;&nbsp;{{item.author}}
                                            </div>
                                            <div class="dt_12c" @click="openDetail(item.id)">
                                                {{getContent(item.content)}}
                                            </div>
                                        </div>
                                    </a-list-item>
                                </a-list>
                            </a-spin>
                        </a-tab-pane>-->
                    </a-tabs>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {findNews} from "@/api/operate/article"
import CustomerService from "@/components/customerService/customerService";
import OnlineMsg from "@/components/onlineMessage/OnlineMessage";

export default {
    components: {
        CustomerService,
        OnlineMsg
    },
    mounted() {

    },
    data() {
        return {
            newsList: [],
            policiesList: [],
            spinning: false,
            search: {
                newsName: "",
                    type: "0",
                    pageNum: "1",
              publicTime:""
                },
                region: {
                    "不限": false,
                    "吴兴区": false,
                    "南浔区": false,
                    "长兴县": false,
                    "安吉县": false,
                    "德清县": false,
                },
                pagination: {
                    current: 1,
                    pageSize: 10,
                    onChange: page => {
                        this.pageChange(page);
                    },
                },
            };
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.initConfig();
            })
        },
        methods: {
            initConfig(){
                this.getProduces();
            },

            //获取新闻
            getProduces() {
                this.spinning = true;

                let formData = new FormData();
                formData.append("newsName", this.search.newsName);
                formData.append("type", this.search.type);
                formData.append("pageNum", this.search.pageNum);
                formData.append("timeStart", this.search.publicTime?this.formatDate(this.search.publicTime[0]["_d"], true) : "");
                formData.append("timeEnd", this.search.publicTime?this.formatDate(this.search.publicTime[1]["_d"], true,"end") : "");

                findNews(formData).then(res => {
                    this.$ajaxAfter(res).then( ()=> {
                        if (res.data.success == "TRUE") {
                            this.newsList = res.data.data.list.list;
                            this.policiesList = res.data.data.list.list;
                            this.pagination = {
                              current: res.data.data.list.pageNum,
                              pageSize: res.data.data.list.pageSize,
                              total: res.data.data.list.total,
                              onChange: page => {
                                this.pageChange(page);
                              },
                            };
                        } else {
                            this.$message.error(res.data.message);
                        }
                        this.spinning = false;
                    })
                }).catch(() => {
                    this.$message.error("服务器出错！请稍后再试!");
                });

            },

            changeType(value){
                this.search.type = value;
                this.search.pageNum = "1";
                this.getProduces();
            },
            pageChange(page) {
                // console.log(11111);
                this.search.pageNum = page;
                this.getProduces();
            },
            getContent(content){
                return content.replace(/<[^>]+>/g,"").replace(/&nbsp;/ig, "");//去掉所有的html标记
            },
            openDetail(id) {
                let routeUrl = this.$router.resolve({
                    name: "newsDetail",
                    query: {id: id}
                });
                window.open(routeUrl.href, '_blank');
            },
          //dates 时间  type 代表是搜索时需要时分秒设置为00:00:00.展示时不手动设置,time代表第二个时间
          formatDate(dates, type, time) {
            let date = {
                  year: dates.getFullYear(),
                  month:
                      dates.getMonth() + 1 < 10
                          ? "0" + (dates.getMonth() + 1)
                          : dates.getMonth() + 1,
                  day:
                      dates.getDate() < 10
                          ? "0" + dates.getDate()
                          : dates.getDate(),
                  hour:
                      dates.getHours() < 10
                          ? "0" + dates.getHours()
                          : dates.getHours(),
                  minute:
                      dates.getMinutes() < 10
                          ? "0" + dates.getMinutes()
                          : dates.getMinutes(),
                  second:
                      dates.getSeconds() < 10
                          ? "0" + dates.getSeconds()
                          : dates.getSeconds()
                },
                times = "00:00:00";
            if (type) {
              if (time) {
                times = "23:59:59";
              }
              return (
                  date.year + "-" + date.month + "-" + date.day + " " + times
              );
            } else {
              return (
                  date.year +
                  "-" +
                  date.month +
                  "-" +
                  date.day +
                  " " +
                  date.hour +
                  ":" +
                  date.minute +
                  ":" +
                  date.second
              );
            }
          },
        }
    };
</script>

<style scoped lang="less">
    .background{
        width: 100%;
        background-color: #f5f5f5;
        position: relative;
        z-index: 1;
        margin: 102px 0 20px 0;
    }
    .nrbj{
        width: 100%;
        height: 360px;
        position: absolute;
        z-index: 3;
        top: 0;
    }

    .nrBox{
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        position: relative;
        z-index: 5;
        padding-top: 50px;
    }

    .jsbanner{
        display: block;
        width: 684px;
        margin: 0 auto;
        margin-bottom: 30px;
    }

    .nrMain{
        width: 100%;
        background-color: #ffffff;
        padding: 20px;
    }

    .search{
        width: 100%;
    }

    .search-form .ant-form-item{
        font-weight: bold;
        width: 100%;
        border-bottom: solid 1px WhiteSmoke;
        padding-top: 5px;
        padding-bottom: 5px;
    }
    .search-form .ant-form-item:nth-child(1){
        border-bottom: 0;
    }

    .condition2 {
        display: flex;
        justify-content: left;
        flex-wrap: wrap;
    }

    .result{
        width: 100%;
    }

    /deep/ .ant-tabs-tab{
        font-size: 16px;
    }
    /deep/ .ant-tabs-nav .ant-tabs-tab-active{
        font-size: 16px;
    }

    .pro_bg{
        width: 100%;
        border-bottom: solid 1px #eeeeee;
        margin-bottom: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor:pointer;
    }

    .dd5{
        height: 99px;
        width: 1200px;
        background: #383d41;margin:0 auto;
    }
    .dd5_copyright{
        color: #fff;
        font-size: 14px;
        text-align: center;
        padding-top:40px;
    }

    .font1 {
        font-size: small;
        font-weight: bolder;
        color: #3bb6f7;
    }

    .font2 {
        font-size: x-large;
        font-weight: bolder;
    }

    .dt_12_5_wz2a{
        font-size: 16px;
        font-weight: 600;
        text-align: left;
        color: #333;
        cursor: pointer;
    }
    .dt_12a{
        font-size: 14px;
        width: 1200px;margin:0px auto;
        text-align: left;
        color: #999999;line-height:40px;cursor: pointer;
    }
    .dt_12b{
        height:1px;width:1120px;background:#eee;margin-top:25px;margin-bottom:5px;
    }
    .dt_12c{
        width: 600px;
        font-size: 14px;
        text-align: left;line-height:24px;
        padding-top:8px;color:#666666;cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
</style>

